module.exports = __webpack_public_path__ + "61af7fa2cc7623ff58b8a50c43cb1478.fbx";